

import {capitalize, isEmpty, phoneNumFormatter} from '../../../../../helpers/utils';
  export const invoiceLogo = (obj) => {

    if(obj.displaySetting.displayLogo) 
    {

      if( !isEmpty(obj.configuration.image)  )
      {
        return obj.configuration.imageBase64
      } else {
        // return "data:image/png;base64,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" ; 
        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAKSURBVHicY2AAAAACAAFIr6RxAAAAAElFTkSuQmCC"
      }

    } else {
      return '';
    }

  }
  export const companyAddress = (obj) =>
  {
    return ( 
      'Address: '        + obj.configuration.companyAddress + "\n" + 
      'Contact Number: ' + (!isEmpty(obj.configuration.companyContactNumber) ? obj.configuration.companyContactNumber : '') + "\n" +
      'Contact Email : ' + obj.configuration.companyEmail
      )  
  }    


  export const chooseHeader = ($type, obj) => {
 
    switch($type){  

      case 1 :
        return header1(obj);
      break;

      case 2 :
        return header2(obj);
      break;
      case 3 :
        return header3(obj);
      break;  
      case 4 :
        return header4(obj);
      break;  
      case 5 :
        return header5(obj);
      break;                   

      default:
        return header1(obj);
      break;
    }
  }

  export const header1 = (obj) => {
    let data =  [
  
     {
       columns: 
     
       [ (obj.displaySetting.displayLogo ? 
         {
           width: "*",
           alignment: "left",

           
           columns: [
             {
               image: invoiceLogo(obj),
               fit: [50, 50],
              
             }
           ],
         }
         : '')
       ]
     },
     {
       columns: 
     
       [
         {
           width: "auto",
           text: [  
             {
               text: obj.configuration.companyName, 
               style: 'header', 
               fontSize: 16,
               margin: [ 0, 0, 0, 0 ]
             },"\n",
             
             (obj.displaySetting.displayCompanyInfo ? 
              {
              text: companyAddress(obj), 
   
              fontSize: 10,
              margin: [ 0, 0, 0, 0 ]
            } : ''),           
           ]       
         },
         {
           width: "*",
           text: [
             {
               text: obj.numberTitle + ": " + obj.prefix+obj.number,
               fontSize: 15,
               bold: true,
               alignment: "right",
               lineHeight: 1.2,
             },
             "\n",
             {
               text: obj.billingDateTitle+": " + obj.billingDateFormated,
               alignment: "right",
             },
             "\n",
             (obj.displaySetting.displayDueDate?
              {
                text: obj.dueDateTitle+": " + obj.dueDateFormated,
                alignment: "right",
              } : ''),
           ],
           margin: [ 0, 0, 0, 0 ]
         },
         
       ]
      }         
   ]
     
   return data;
  
   }

  export const header2 = (obj) => {
         let data =  [

          {
            columns: 
          
            [ (obj.displaySetting.displayLogo ?
              {
                width: "auto",
                columns: [
                  {
                    image: invoiceLogo(obj),
                    width: 50,
                    // height: 100,
                  }
                  
                ],
                
              } : ''),
              
              {
                width: "*",
                text: [
                  {
                    text: obj.numberTitle + ": " + obj.prefix+obj.number,
                    fontSize: 15,
                    bold: true,
                    alignment: "right",
                    lineHeight: 1.2,
                  },
                  "\n",
                  {
                    text: obj.billingDateTitle+": " + obj.billingDate,
                    alignment: "right",
                  },
                  "\n",
                  (obj.displaySetting.displayDueDate?
                    {
                      text: obj.dueDateTitle+": " + obj.dueDate,
                      alignment: "right",
                    } : ''),                  
                ],
              },
            ]
          },
          
          {
            text: obj.configuration.companyName, 
            style: 'header', 
            fontSize: 16,
            margin: [ 0, 10, 0, 0 ]
          },
          {
            text: companyAddress(obj)
          },          
        ]
          
        return data;

        }



    export const header3 = (obj) => {
      let data =  [

       {
      columns:     
            [
              {
                width: "*",
                text: [
                  {
                    text: obj.numberTitle + ": " + obj.prefix+obj.number,
                    fontSize: 15,
                    bold: true,
                    alignment: "left",
                    lineHeight: 1.2,
                  },
                  "\n",
                  {
                    text: obj.billingDateTitle+": " + obj.billingDate,
                    alignment: "left",
                  },
                  "\n",

                  (obj.displaySetting.displayDueDate?
                    {
                      text: obj.dueDateTitle+": " + obj.dueDate,
                      alignment: "left",
                    } : ''),   

                ],
              },      
              {
                width: "auto",
                columns: [
                  {
                    image: invoiceLogo(obj),
                    width: 50,
                    alignment: "right",
                    // height: 100,
                  },
                  
                ],
              }               
            ]   
          },
          {
            text: obj.configuration.companyName, 
            style: 'header', 
            fontSize: 16,
            margin: [ 0, 10, 0, 0 ],
            alignment: "right",
          },
          {
            text: companyAddress(obj),
            alignment: "right",
          },  
  
]
          
return data;

}


export const header4 = (obj) => {
  let data =  [

   {
     columns: 
   
     [ (obj.displaySetting.displayLogo ? 
       {
         width: "*",
         alignment: "center",
         columns: [
           {
             image: invoiceLogo(obj),
             fit: [50, 50],
            
           }
         ],
       }
       : '')
     ]
   },
   {
    columns: 
  
    [ (obj.displaySetting.displayLogo ? 
      {
        width: "*",
        alignment: "center",
        columns: [
          {
            text: obj.configuration.companyName, 
            style: 'header', 
            fit: [50, 50],
            fontSize: 16,
           
          }
        ],
      }
      : '')
    ]
  },   
   {
     columns: 
   
     [
       {
         width: "auto",
         text: [  

           
           (obj.displaySetting.displayCompanyInfo ? 
            {
            text: companyAddress(obj), 
 
            fontSize: 10,
            margin: [ 0, 0, 0, 0 ]
          } : ''),           
         ]       
       },
       {
         width: "*",
         text: [
           {
             text: obj.numberTitle + ": " + obj.prefix+obj.number,
             fontSize: 15,
             bold: true,
             alignment: "right",
             lineHeight: 1.2,
           },
           "\n",
           {
             text: obj.billingDateTitle+": " + obj.billingDateFormated,
             alignment: "right",
           },
           "\n",

           (obj.displaySetting.displayDueDate?
            {
              text: obj.dueDateTitle+": " + obj.dueDateFormated,
              alignment: "right",
            } : ''), 

         ],
         margin: [ 0, 0, 0, 0 ]
       },
       
     ]
    }         
 ]
   
 return data;

 }

export const header5 = (obj) => {
  let data =  [
  
    {
      columns: 
    
      [ (obj.displaySetting.displayLogo ? 
        {
          width: "*",
          alignment: "right",

          
          columns: [
            {
              image: invoiceLogo(obj),
              fit: [50, 50],
             
            }
          ],
        }
        : '')
      ]
    },
    {
      columns: 
    
      [
        {
          width: "*",
          text: [
            {
              text: obj.numberTitle + ": " + obj.prefix+obj.number,
              fontSize: 15,
              bold: true,
              alignment: "left",
              lineHeight: 1.2,
            },
            "\n",
            {
              text: obj.billingDateTitle+": " + obj.billingDateFormated,
              alignment: "left",
            },
            "\n",
            (obj.displaySetting.displayDueDate?
              {
                text: obj.dueDateTitle+": " + obj.dueDateFormated,
                alignment: "left",
              } : ''), 


          ],
          margin: [ 0, 0, 0, 0 ]
        },        
        {
          width: "auto",
          text: [  
            {
              alignment: "right",
              text: obj.configuration.companyName, 
              style: 'header', 
              fontSize: 16,
              margin: [ 0, 0, 0, 0 ]
            },"\n",
            
            (obj.displaySetting.displayCompanyInfo ? 
             {
             text: companyAddress(obj), 
             alignment: "right",
             fontSize: 10,
             margin: [ 0, 0, 0, 0 ]
           } : ''),           
          ]       
        }

        
      ]
     }         
  ]
    
  return data;
 
  }










// const headers = new Headers();
// export default headers.header;